import { Core } from "@faire/design-tokens";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { optimizeImageUrl } from "@faire/web--source/common/transform-images";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { FaireLogo } from "@faire/web--source/slate/logos/FaireLogo";
import * as React from "react";
import styled from "styled-components";

import { home } from "@faire/retailer/paths";

export const MakerSignUpMobileWrapper: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const isSSR = useIsSSR();
  return (
    <MobileWrapper>
      <ImageWrapper $isSSR={isSSR}>
        <Button variant="tertiary" linkTo={home()}>
          <FaireLogo size={100} />
        </Button>
      </ImageWrapper>
      <SummarySection>{children}</SummarySection>
    </MobileWrapper>
  );
};

const MobileWrapper = styled(Column)`
  max-height: 100vh;
`;

const ImageWrapper = styled.div<{ $isSSR: boolean }>`
  padding: 24px;
  height: 490px;
  width: 100%;
  background-image: url(${({ $isSSR }) =>
    optimizeImageUrl(
      {
        url: "https://cdn.faire.com/fastly/a2433fe4b864a396996e79b48f5b39939f1353d65ea2cb4439823e87dc29e3eb.png",
      },
      $isSSR,
      {
        height: 490,
      }
    )});
  position: absolute;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;

const SummarySection = styled(Column)`
  position: absolute;
  bottom: 0;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  background-color: ${Core.surface.inverse};
  z-index: 1;
`;
